
/**
 * ContraSenhaDestinatario
 * @author Thacryba
 */
import {$, HttpBody, ID, Resource, ResponseHidden, ResponseSerialize} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'

export default class ContraSenhaDestinatario extends Resource {
  static async listContraSenhaDestinatario(spinner = 'listContraSenhaDestinatario') {
    const fetch = async () => {
      // @ts-ignore
      return await new HttpBody<ContraSenhaDestinatario[]>(ContraSenhaDestinatario)
          .GET('/user/contra-senha-destinatario')
    }

    return await $.await.run(fetch, spinner)
  }

  static async listCpfCnpjContraSenhaDestinatario(spinner = 'listCpfCnpjContraSenhaDestinatario') {
    const fetch = async () => {
      return await new HttpBody<string[]>(Array).GET('/user/contra-senha-destinatario/cpfCnpj')
    }

    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'ContraSenhaDestinatario'

  readonly $endpoint: string = '/user/contra-senha-destinatario{/id}'

  get $id() {
    return this.cpfCnpj || ''
  }

  get $tag() {
    return this.cpfCnpj ? Helper.cpfOrCnpj(this.cpfCnpj) : ''
  }

  @ResponseSerialize(Responsavel)
  responsavel = new Responsavel()

  celDestinatario: string | null = null
  cpfCnpj: string | null = null

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  async listContraSenhasByCpfCnpj(spinner = 'listContraSenhasByCpfCnpj') {
    const fetch = async () => {
      return await new HttpBody<string[]>(Array).GET(`/user/contra-senha-destinatario/${this.cpfCnpj}`)
    }

    return await $.await.run(fetch, spinner)
  }
}
